import currency from 'currency.js';

export const dollarsToCents: (dollars: number) => number = (dollars) => {
  return currency(dollars).intValue;
};

export const centsToDollars: (cents: number) => number = (cents) => {
  return currency(cents, { fromCents: true }).value;
};

export const displayAmount = (value: number, fromCents = true): string => {
  return currency(value, { fromCents }).format();
};

/**
 * Format a money amount with options to show/hide cents and convert from cents
 * @param amount The amount to format
 * @param options Configuration options
 * @param options.fromCents Whether the amount is in cents (defaults to false)
 * @param options.showCents Whether to show cents in the formatted output (defaults to false)
 * @returns Formatted money string
 */
export const formatMoneyAmount = (
  amount: number,
  options: { fromCents?: boolean; showCents?: boolean } = {},
): string => {
  const { fromCents = false, showCents = true } = options;

  // Convert from cents if needed
  const value = fromCents ? centsToDollars(amount) : amount;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: showCents ? 2 : 0,
    minimumFractionDigits: showCents ? 2 : 0,
  });

  return formatter.format(value);
};
